// useBoqCreateCustomSubtrade.js
//
// Phase 3.5 of the BOQ estimate-template feature. Wraps the server-side
// boq.create_custom_subtrade(p_trade_label, p_subtrade_label, p_default_unit,
// p_note) RPC. Surface mirrors the other RPC hooks (useBoqBillVersions,
// useBoqSeedFromTemplate): returns `{ success, result?, error? }`.

import { useCallback, useState } from 'react';
import { supabase } from '../../supabaseClient';
import { formatSupabaseError } from '../../hooks/useSupabase';

export default function useBoqCreateCustomSubtrade() {
  const [submitting, setSubmitting] = useState(false);

  const createCustomSubtrade = useCallback(
    async ({ tradeLabel, subtradeLabel, defaultUnit = 'lump', note } = {}) => {
      if (!tradeLabel || !subtradeLabel) {
        return { success: false, error: 'Trade and subtrade labels are required.' };
      }
      setSubmitting(true);
      try {
        const { data, error: rpcErr } = await supabase.schema('boq').rpc(
          'create_custom_subtrade',
          {
            p_trade_label: tradeLabel,
            p_subtrade_label: subtradeLabel,
            p_default_unit: defaultUnit,
            ...(note ? { p_note: note } : {}),
          }
        );
        if (rpcErr) throw rpcErr;
        return { success: true, result: data };
      } catch (err) {
        console.error('[useBoqCreateCustomSubtrade] failed', err);
        return {
          success: false,
          error: formatSupabaseError(err, { action: 'create', entity: 'custom subtrade' }),
        };
      } finally {
        setSubmitting(false);
      }
    },
    []
  );

  return { createCustomSubtrade, submitting };
}
